import { useKlipyApiKey } from '@/hooks/useKlipyApiKey';
import { configureKlipyProvider } from '@/services/media/providers/klipy';

/**
 * Pushes per-community media provider configuration (e.g. Klipy API keys) into
 * each provider's module-level state during the render phase so that
 * provider-agnostic consumers (composer, registry's `defaultFor`) can ask
 * `isConfigured()` without depending on React context themselves.
 *
 * Must be mounted inside `AuthProvider` so `useCommunity` (and therefore
 * `useKlipyApiKey`) can resolve the active community.
 */
export function MediaConfigSync() {
  const klipyApiKey = useKlipyApiKey();
  configureKlipyProvider({ apiKey: klipyApiKey });
  return null;
}
